export const ICMSIPI = 1;
export const PISCOFINS = 2;



// WEBPACK FOOTER //
// ./src/public/api/spedType.js